import styled from 'styled-components';

const CPFTitle = styled.div`
    background-color: ${props => props.theme.color};
    color: #FFF;
    font-size: 0.75rem;

    .cpf_month {
        padding: 0.688rem 0 0.688rem 1.25rem;
        width: 19%;
    }

    .cpf_paid {
        width: 22.5%;
        padding: 0.688rem 0 0.688rem 0.875rem;
    }

    .cpf_amount {
        width: 16.5%;
        padding: 0.688rem 0 0.688rem 0.875rem;
    }

    .cpf_contribution {
        padding: 0.688rem 1.25rem 0.688rem 0.938rem;
        width: 42%;
    }
`;

export default CPFTitle;